import { useAsync } from 'react-async-hook';
import { getColours } from 'apiCalls/apiCalls';
import { useEffect, useMemo, useState } from 'react';

const uninitiatedColourPalette = {
    name: '',
    colours: []
};

const getSelectedColoursFromColourPalette = (colourPalette) => {
    return colourPalette.colours.map((colour) => ({...colour, selected: true}))
        .sort((a, b) => a.position - b.position);
}

const getColoursWithSelectedProperty = (colours, selectedColours) => {
    const selectedColourIds = selectedColours.map((selectedColour) => selectedColour.id);

    return colours.map((colour) => {
        return selectedColourIds.includes(colour.id) ? {...colour, selected: true} : {...colour, selected: false}
    })
}

export const useColourPaletteStateRefactor = (existingColourPalette = uninitiatedColourPalette) => {
    const coloursFromApi = useAsync(getColours, []);

    const [apiRequestStatus, setApiRequestStatus] = useState({loading: true, error: false});
    const [colours, setColours] = useState(null);
    const [selectedColours, setSelectedColours] = useState(null);
    const [name, setName] = useState(null);

    const apiResult = useMemo(() => {
        switch (coloursFromApi.status) {
            case 'loading': {
                return {
                    loading: true,
                };
            }

            case 'success': {
                return {
                    loading: false,
                    result: coloursFromApi.result,
                };
            }

            case 'error': {
                return {
                    loading: false,
                    error: coloursFromApi.error,
                };
            }
        }
    }, [coloursFromApi.status, coloursFromApi.error, coloursFromApi.result]);

    useEffect(() => {
        if(apiResult.error) {
            setApiRequestStatus({loading: false, error: true})
        }

        if (apiResult.result) {
            setColours(getColoursWithSelectedProperty(apiResult.result, existingColourPalette.colours));
            setSelectedColours(getSelectedColoursFromColourPalette(existingColourPalette));
            setName(existingColourPalette.name);
            setApiRequestStatus({loading: false, error: false});
        }
    }, [apiResult, existingColourPalette]);

    return [apiRequestStatus, colours, setColours, selectedColours, setSelectedColours, name, setName];
};
